"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADER_REQUEST_ID = exports.HEADER_CORRELATION_ID = exports.HEADER_SELLER_ID = exports.HEADER_RATE_LIMIT_RESET = exports.HEADER_RATE_LIMIT_REMAINING = exports.HEADER_RATE_LIMIT_LIMIT = exports.HEADER_RATE_LIMIT_RETRY_AFTER = exports.HEADER_IDEMPOTENCY_REPLAYED = exports.HEADER_IDEMPOTENCY_KEY = exports.HEADER_SHOPIFY_PARTNER_ID = exports.HEADER_SHOPIFY_ACCESS_TOKEN = exports.HEADER_SHOPIFY_LOGISTICS_ACCOUNT_ID = void 0;
/**
 * Logistics API consumers should pass this header for account-specific requests.
 * Logistics API developers should not use this header directly in controllers.
 * Account context should be accessed via koa or GraphQL context instead.
 */
exports.HEADER_SHOPIFY_LOGISTICS_ACCOUNT_ID = "x-shopify-logistics-account-id";
/**
 * API client access token that Shopify partner creates in the Partner Dashboard:
 * https://shopify.dev/api/partner#create-a-partner-api-client
 * @deprecated with Partners Auth V2
 */
exports.HEADER_SHOPIFY_ACCESS_TOKEN = "x-shopify-access-token";
/**
 * If access token authorization is used, partner id must be sent as a header
 * @deprecated with Partners Auth V2
 */
exports.HEADER_SHOPIFY_PARTNER_ID = "x-shopify-partner-id";
/**
 * The HTTP idempotency-key request header field can be used to carry an idempotency key
 * in order to make non-idempotent HTTP methods such as POST or PATCH fault-tolerant.
 * https://www.ietf.org/id/draft-ietf-httpapi-idempotency-key-header-01.html
 */
exports.HEADER_IDEMPOTENCY_KEY = "idempotency-key";
/**
 * If a previously executed response is being replayed by the server, the response will include the header Idempotent-Replayed: true.
 */
exports.HEADER_IDEMPOTENCY_REPLAYED = "idempotent-replayed";
/**
 * The timestamp after which the next request will be allowed
 */
exports.HEADER_RATE_LIMIT_RETRY_AFTER = "retry-after";
/**
 * The number of allowed requests in the current period
 */
exports.HEADER_RATE_LIMIT_LIMIT = "x-ratelimit-limit";
/**
 * The number of remaining requests in the current period
 */
exports.HEADER_RATE_LIMIT_REMAINING = "x-ratelimit-remaining";
/**
 * The number of seconds left in the current period
 */
exports.HEADER_RATE_LIMIT_RESET = "x-ratelimit-reset";
exports.HEADER_SELLER_ID = "x-seller-id";
exports.HEADER_CORRELATION_ID = "x-correlation-id";
exports.HEADER_REQUEST_ID = "x-request-id";
//# sourceMappingURL=Headers.js.map